'use client';

import { useEffect, useState } from 'react';
import { PhotoView } from 'react-photo-view';
import { Box, Image, Skeleton } from '@mantine/core';

interface IChatAttachmentImageProps {
  size?: 'sm' | 'md';
  imageUrl: string;
  thumbnailUrl: string;
}

const MAX_RETRIES = 5;

export default function ChatAttachmentImage({
  size = 'md',
  imageUrl,
  thumbnailUrl,
}: IChatAttachmentImageProps) {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isNormalSize = size === 'md';
  const imageSize = isNormalSize ? '4rem' : '3rem';

  useEffect(() => {
    let retriesCount = 0;
    const preloadImage = () => {
      const image = new window.Image();
      image.src = imageUrl;
      image.onload = () => setIsLoaded(true);

      image.onerror = () => {
        if (retriesCount < MAX_RETRIES) {
          retriesCount++;
          setTimeout(preloadImage, 1000);
        }
      };
    };

    preloadImage();
  }, [imageUrl]);

  return (
    <Box w={imageSize} h={imageSize}>
      {isLoaded ? (
        <Box className="cursor-pointer">
          <PhotoView src={imageUrl}>
            <Image src={thumbnailUrl} bdrs="0.4rem" />
          </PhotoView>
        </Box>
      ) : (
        <Skeleton w="100%" h="100%" />
      )}
    </Box>
  );
}
